import PropTypes from "prop-types";

const Circle = ({ color, percentage, fill }) => {
  const r = 22 * 0.9;
  const circumference = 2 * Math.PI * r;
  const percentCalculation = 1 - percentage / 100;
  return (
    <circle
      data-testid="circle"
      r={r}
      cx={22}
      cy={22}
      fill={fill}
      stroke={percentage !== 0 ? color : ""} // remove colour as 0% sets full circumference
      strokeWidth={2}
      strokeDasharray={`${circumference}`}
      strokeDashoffset={`${circumference * percentCalculation}`}
      style={{ transform: "rotate(-90deg)", transformOrigin: "50% 50%" }}
    />
  );
};

Circle.propTypes = {
  color: PropTypes.string.isRequired,
  percentage: PropTypes.number,
  fill: PropTypes.string,
};

export default Circle;
